import React from 'react';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';

const RenderTextField = ({
  input,
  label,
  meta,
  helperText,
  style,
  inputProps,
  type,
  disabled,
  variant,
  multiline,
  fullWidth,
  id,
  rows,
  InputLabelProps,
  displayErrorBeforeSubmit
}) => {
  let displayError;
  if (displayErrorBeforeSubmit) {
    displayError = !!meta.error;
  } else {
    displayError = !!(meta.submitFailed && meta.error);
  }
  return (
    <TextField
      label={label}
      id={id}
      helperText={displayError ? meta.error : helperText}
      style={style}
      error={displayError}
      InputProps={{
        ...inputProps,
        'data-hj-whitelist': true
      }}
      fullWidth={fullWidth}
      InputLabelProps={InputLabelProps}
      multiline={multiline}
      rows={rows}
      variant={variant}
      type={type}
      disabled={disabled}
      {...input}
    />
  );
};

RenderTextField.propTypes = {
  label: PropTypes.string.isRequired,
  helperText: PropTypes.string,
  fullWidth: PropTypes.bool,
  style: PropTypes.object,
  meta: PropTypes.object.isRequired,
  inputProps: PropTypes.object,
  input: PropTypes.object.isRequired,
  type: PropTypes.string,
  variant: PropTypes.string,
  multiline: PropTypes.bool,
  rows: PropTypes.string,
  id: PropTypes.string,
  InputLabelProps: PropTypes.string,
  disabled: PropTypes.bool,
  displayErrorBeforeSubmit: PropTypes.bool
};

export default RenderTextField;
